import React from 'react'
import PropTypes from 'prop-types'
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Button, Tooltip } from 'antd'

const RepositoryLineAction = ({ actions }) => {
  return actions.map((action, index) => {
    return (
      <Tooltip key={index} placement="topLeft" title={action.title}>
        <Button onClick={action.onExecute} icon={<LegacyIcon type={action.icon} />} disabled={action.disabled} />
      </Tooltip>
    );
  });
}

RepositoryLineAction.propTypes = {
  actions: PropTypes.array.isRequired
}

export default RepositoryLineAction
